/**
 * @Author: Colin Osterhout <ctosterhout>
 * @Date:   2019-05-06T16:58:43-08:00
 * @Email:  ctosterhout@alaska.edu
 * @Last modified by:   ctosterhout
 * @Last modified time: 2020-01-20T10:53:04-09:00
 * @License: Released under MIT License. copyright 2019 University of Alaska Southeast.  For more details, see https://opensource.org/licenses/MIT
 */

const prefix = process.env.VUE_APP_MODE === 'production'
  ? ''
  : '/cms/tests/acrc'

const urlMangle = function (url) {
  return `${prefix}${url}`
}

export default urlMangle
